<app-base-page pageTitle="Search Policies"
	[pageContext]="pageContext"
	utilityMenuOperationGroupName="">

	<div class="search-filter-container"
		*ngIf="!loadingTransactionTypes">
		<div class="ui-g-12">
			<div>
				<app-dynamic-formly
					#DynamicFormlyComponent
					[dataSet]="dataSet"
					[layoutSchema]="dynamicFormly"
					[context]="context"
					(validityChanged)="formValidityChange($event)">
				</app-dynamic-formly>
				<div class="ui-g-12 ui-md-6 text-right button-set search-policy-button-set">
					<button
						pButton
						type="button"
						label="Search"
						class="no-margin-right"
						(click)="search()"
						[disabled]="validForm !== true">
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="ui-g">
		<div *ngIf="loadingTableDefinitions === true"
			class="text-center ui-g-12">
			<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size">
			</span>
		</div>

		<div class="ui-g-12 table-container"
			*ngIf="loadingTableDefinitions === false && searchMode === true"
			[@contentAnimation]="state">
			<app-common-table
				[tableDefinitions]="policySearchTableDefinitions">
			</app-common-table>
		</div>
	</div>

</app-base-page>